import React, { useEffect, useState } from 'react';

import { getUserAnalytics } from '@/api/fetch/marketplace-api';
import { AnalyticsResponse, LeadsCount } from '@/api/gen-protos/ads_pb';
import { UserByIDRequest } from '@/api/gen-protos/users_pb';
import { UserAtom } from '@/modules/core/store/grpc-free-store';
import { IListingItem, Itransaction } from '@/modules/core/types';

import BigStats from './BigStats';
import Tables from './Tables';
import { UserType } from '../../types';

interface IAlert {
  title: string;
  searchParams: string[];
  viewResult: () => void;
  deleteAlert: () => void;
}
interface ProDashboardTabProps {
  classifieds: IListingItem[];
  userData: UserAtom;
  balance: number;
  transactionList: Itransaction[];
  alerts: IAlert[];
}

const ProDashboardTab: React.FC<ProDashboardTabProps> = ({
  classifieds,
  userData,
  balance,
  transactionList,
  alerts,
}) => {
  const [totalClicks, setTotalClicks] = useState<number>(0);
  const [chatLeads, setChatLeads] = useState<number>(0);
  const [whatsAppLeads, setWhatsAppLeads] = useState<number>(0);
  const [showPhoneLeads, setShowPhoneLeads] = useState<number>(0);
  const [Leads, setLeads] = useState<LeadsCount | undefined>(undefined);
  const [ContactFormLeads, setcontactFormLeads] = useState<number>(0);

  useEffect(() => {
    if (userData.userType === UserType.PRO) {
      const token = localStorage.getItem('auth_token');
      const request = new UserByIDRequest();
      request.setKcid(userData.kcid || '');

      getUserAnalytics(token, request)
        .then((data: AnalyticsResponse) => {
          setLeads(data.getLeads());
          setTotalClicks(data?.getTotalclicks());
          setChatLeads(data?.getLeads()?.getChatleads() || 0);
          setWhatsAppLeads(data.getLeads()?.getWhatsappleads() || 0);
          setShowPhoneLeads(data.getLeads()?.getShowphoneleads() || 0);
          setcontactFormLeads(data?.getLeads()?.getContactformleads() || 0);
        })
        .catch((_error: Error) => {});
    }
  }, [userData.userType, userData.kcid]);

  const totalLeads =
    chatLeads + whatsAppLeads + showPhoneLeads + ContactFormLeads;

  return (
    <>
      <div className="">
        <p className="text-3xl text-neutral-400">
          Bonjour{' '}
          <span className="font-extrabold text-neutral-500">
            {userData.fullname}
          </span>
        </p>
      </div>

      <BigStats
        totalLeads={totalLeads}
        totalViews={totalClicks}
        weeklyLeads={[]} // Removed weekly calculation
        weeklyViews={[]} // Removed weekly calculation
        alerts={alerts}
        balance={balance}
        transactionList={transactionList}
        Leads={Leads}
      />

      <Tables
        data={classifieds}
        leadsData={[
          {
            id: '0',
            title: 'Prospects',
            value: totalLeads,
            description: 'Personnes sont intéressées par votre annonce',
            history: [],
          },
        ]} // Adjusted leads data
        viewsData={[
          {
            id: '0',
            title: 'Clics',
            value: totalClicks,
            description: 'Personnes ont visité votre annonce',
            history: [],
          },
        ]} // Adjusted views data
        transactionList={transactionList}
      />
    </>
  );
};

export default ProDashboardTab;
